import TransparentCard from '@/components/ui/transparent-card'
import Layout from '../../components/layout/Layout'
import JapaneseCharacter from '../../components/ui/japanese-character'
import { ASSETS } from '@/constants/assets'

const VisualDesign = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Visual Design Language and Personality
        </h1>

        <div className="mt-12 flex flex-row gap-8 items-start">
          <div className="w-full md:w-1/4 min-w-[calc(100vw-2rem)] md:min-w-[340px]">
            <TransparentCard
              title="Benevolent dictatorship"
              className="aspect-[17/20] w-full"
            />
          </div>
          <div className="w-full md:w-3/4 flex items-center">
            <p className="text-foreground text-lg leading-relaxed">
              A benevolent dictatorship is a government in which an authoritarian leader exercises absolute political power over the state but is perceived to do so with regard for the benefit of the population as a whole. It stands in contrast to the decidedly malevolent stereotype of a dictator, who focuses on their supporters and their own self-interests.
            </p>
          </div>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="w-full">
            <img
              src={ASSETS.images.mobileMock}
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full">
            <img
              src={ASSETS.images.mobileMock}
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 w-full">
          <div className="w-full">
            <img
              src={ASSETS.images.mobileMock}
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full">
            <img
              src={ASSETS.images.mobileMock}
              alt="Mobile interface mockup showing Finance Checker and File Exporter status list"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
          <div className="col-span-1">
            <JapaneseCharacter className="text-foreground" />
          </div>
          <div className="col-span-3 flex items-center">
            <p className="text-foreground text-lg leading-relaxed">
              Wa (和) is a Japanese cultural concept usually translated into English as "harmony". It implies a peaceful unity and conformity within a social group in which members prefer the continuation of a harmonious community over their personal interests. The kanji character wa (和) is also a name for "Japan".
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row gap-8 items-start">
          <div className="w-full md:w-1/4 min-w-[calc(100vw-2rem)] md:min-w-[340px]">
            <JapaneseCharacter className="text-foreground w-full h-auto" />
          </div>
          <div className="w-full md:w-3/4 flex items-center">
            <p className="text-foreground text-lg leading-relaxed">
              Wa (和) is a Japanese cultural concept usually translated into English as "harmony". It implies a peaceful unity and conformity within a social group in which members prefer the continuation of a harmonious community over their personal interests. The kanji character wa (和) is also a name for "Japan".
            </p>
          </div>
        </div>
        
        <p className="mt-8 text-foreground text-lg leading-relaxed">
          Developing personality through visual language is important because it establishes a unique and memorable identity that resonates with users on an emotional level. Visual elements such as color, typography, shapes, and imagery work together to communicate values, tone, and intent, transforming functional designs into meaningful experiences.
        </p>

        <hr className="border-t border-foreground my-12" />

        <div className="mt-12 flex flex-row gap-8 items-start">
          <div className="w-full md:w-3/4">
            <p className="text-foreground text-lg leading-relaxed">
              The kanji 愛 (ai), meaning "love," embodies deep affection, care, and compassion, extending beyond romantic relationships to include unconditional love and universal empathy. Rooted in Japanese culture, it reflects selflessness, nurturing connections, and fostering understanding through kindness and empathy. Similar to 和 (wa), which emphasizes harmony within a group, 愛 represents a personal and universal commitment to cherish and uplift others, promoting unity and benevolence across all relationships.
            </p>
          </div>
          <div className="w-full md:w-1/4">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/SVGOMG%20Image%20(3)-oNyogCftJRkaQRwlrXmGLWBYFmqmRR.svg"
              alt="Stylized Japanese kanji character for love (ai)"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default VisualDesign 